import { createSlice } from '@reduxjs/toolkit';

const initialStateProto = {
  isTourOpen: false,
};

export const watcheventTourSlice = createSlice({
  name: 'watcheventTour',
  initialState: initialStateProto,
  reducers: {
    updateTour: (state, action) => {
      const { status } = action.payload;
      return {
        ...state,
        isTourOpen: status,
      };
    },

    openTour: (state, action) => {
      return { ...state, isTourOpen: true };
    },

    closeTour: (state, action) => {
      return { ...state, isTourOpen: false };
    },

    clearForm: () => {
      return { ...initialStateProto };
    },
  },
});

export const { updateTour, openTour, closeTour, clearForm } =
  watcheventTourSlice.actions;

export default watcheventTourSlice.reducer;
